import { yupResolver } from "@hookform/resolvers/yup";
import {
  commandTypes,
  formatDateToReadable,
  formatFileSize,
} from "components/utils";
import dayjs from "dayjs";
import { string } from "yup";
import { executeCommand } from "../../../redux/saga/socket";
import PeopleIcon from "../../../static/svgs/People";
import RegisterSettingsIcon from "../../../static/svgs/RegisterSettings";
import MyBadge from "../../shared/MyBadge";
import theme from "../../utils/theme";

export const windowsAppColumns = [
  {
    field: "Name",
    headerName: "App Name",
    minWidth: 120,
    flex: 1,
  },
  {
    field: "Vendor",
    headerName: "Vendor",
    minWidth: 70,
    flex: 2,
  },
  {
    field: "Version",
    headerName: "Version",
    minWidth: 120,
    flex: 2,
  },
  {
    field: "InstallLocation",
    headerName: "InstallLocation",
    minWidth: 120,
    flex: 2,
  },
  {
    field: "type",
    headerName: "Type",
    minWidth: 120,
    flex: 2,
  },
];

export const linuxAppColumns = [
  {
    field: "Package",
    headerName: "File Name",
    width: 160,
  },
  {
    field: "Version",
    headerName: "Version",
    width: 180,
  },
  {
    field: "Description",
    headerName: "Description",
    width: 300,
  },
  {
    field: "InstalledSize",
    headerName: "Size",
    width: 100,
  },
  {
    field: "Maintainer",
    headerName: "Maintainer",
    width: 400,
  },

  {
    field: "Architecture",
    headerName: "Architecture",
    width: 150,
  },
  {
    field: "Depends",
    headerName: "Depends",
    width: 150,
  },
  {
    field: "Status",
    headerName: "Status",
    width: 150,
  },
];

export const WINDOWS_APP_DOWNLOAD_COLS = [
  { field: "name", headerName: "App Name" },
  { field: "signature", headerName: "Signature" },
  { field: "location", headerName: "InstallLocation" },
];

export const LINUX_APP_DOWNLOAD_COLS = [
  { field: "Name", headerName: "File Name" },
  { field: "Version", headerName: "Version" },
  { field: "Description", headerName: "Description" },
  { field: "Size", headerName: "Installed Size in Bytes" },
  { field: "Signature", headerName: "Signature" },
  { field: "InstallLocation", headerName: "Install Location" },
];

export const systemAppsColumns = [
  {
    field: "Name",
    headerName: "File Name",
    minWidth: 120,
    flex: 1.2,
  },

  {
    field: "Vendor",
    headerName: "Vendor",
    minWidth: 100,
    flex: 0.5,
    // renderCell: (params) => formatDateToReadable(params?.row?.InstallDate),
  },
  {
    field: "Version",
    headerName: "Version",
    minWidth: 70,
    flex: 0.7,
  },
  {
    field: "InstallLocation",
    headerName: "InstallLocation",
    minWidth: 120,
    flex: 1,
  },
  {
    field: "type",
    headerName: "Type",
    minWidth: 120,
    flex: 1,
  },
];

export const linuxSystemAppColumns = [
      {
    field: "Package",
    headerName: "Package",
    minWidth: 120,
    flex: 1.2,
  },
  {
    field: "Version",
    headerName: "Version",
    minWidth: 100,
    flex: 0.5,
  },
  {
    field: "Architecture",
    headerName: "Architecture",
    minWidth: 70,
    flex: 0.7,
  }, {
    field: "InstalledSize",
    headerName: "Installed Size",
    minWidth: 120,
    flex: 1,
  }, {
    field: "Maintainer",
    headerName: "Maintainer",
    minWidth: 120,
    flex: 1,
  },{
    field: "Description",
    headerName: "Description",
    minWidth: 150,
    flex: 1.5,
  },{
    field: "Status",
    headerName: "Status",
    minWidth: 120,
    flex: 1,
  },{
    field: "Depends",
    headerName: "Depends",
    minWidth: 150,
    flex: 1.5,
    
  }
]

export const WINDOWS_SYSTEM_APP_DOWNLOAD_COLS = [
  { field: "Name", headerName: "App Name" },
  { field: "InstallDate", headerName: "InstallDate", type: "date" },
  { field: "Version", headerName: "Version" },
  { field: "InstallLocation", headerName: "InstallLocation" },
  { field: "Publisher", headerName: "Publisher" },
];

export const userAppsColumnsLinux = [
  {
    field: "Name",
    headerName: "File Name",
    minWidth: 120,
    flex: 1.2,
  },

  {
    field: "InstallDate",
    headerName: "Install Date",
    minWidth: 100,
    flex: 0.5,
    renderCell: (params) =>
      dayjs(params?.row?.InstallDate).format("DD-MM-YYYY"),
  },
  {
    field: "Version",
    headerName: "Version",
    minWidth: 70,
    flex: 0.7,
  },
  {
    field: "InstallLocation",
    headerName: "InstallLocation",
    minWidth: 120,
    flex: 1,
  },
  {
    field: "Publisher",
    headerName: "Publisher",
    minWidth: 120,
    flex: 1,
  },
];

export const getStatusBadge = (name) => {
  // eslint-disable-next-line default-case
  switch (name) {
    case "Installed":
      return (
        <MyBadge
          title={name}
          bgColor={theme.palette.success.light}
          txtColor={theme.palette.success.main}
        />
      );
    case "Pending":
      return (
        <MyBadge
          title={name}
          bgColor={theme.palette.brown.light}
          txtColor={theme.palette.brown.main}
        />
      );
  }
};

export const getActiveBadge = (name) => {
  // eslint-disable-next-line default-case
  switch (name) {
    case "Known":
      return (
        <MyBadge
          title={name}
          bgColor={theme.palette.white.dark}
          txtColor={theme.palette.success.main}
        />
      );
    case "UnKnown":
      return (
        <MyBadge
          title={name}
          bgColor={theme.palette.white.dark}
          txtColor={theme.palette.brown.main}
        />
      );
  }
};

export const getRoleBadge = (name) => {
  // eslint-disable-next-line default-case
  switch (name) {
    case "General":
      return (
        <MyBadge
          title={name}
          bgColor={theme.palette.success.light}
          txtColor={theme.palette.text.primary}
        />
      );
    case "Admin":
      return (
        <MyBadge
          title={name}
          bgColor={theme.palette.brown.light}
          txtColor={theme.palette.brown.main}
        />
      );
    case "Creator":
    case "User":
      return (
        <MyBadge
          title={name}
          bgColor={theme.palette.white.dark}
          txtColor={theme.palette.text.primary}
        />
      );
  }
};

export const getActiveStatusBadge = (name) => {
  // eslint-disable-next-line default-case
  switch (name) {
    case "Active":
      return (
        <MyBadge
          title={name}
          bgColor={theme.palette.success.light}
          txtColor={theme.palette.success.main}
        />
      );
    case "In Active":
      return (
        <MyBadge
          title={name}
          bgColor={theme.palette.brown.light}
          txtColor={theme.palette.brown.main}
        />
      );
  }
};

export const getAppInstalledItems = (total, active, registered) => {
  return [
    {
      value: total,
      label: "User Apps",
      icon: <PeopleIcon />,
      color: theme.palette.primary.light,
    },
    // { value: active, label: 'Active Apps', icon: <UsersIcon />, color: theme.palette.secondary.main },
    // { value: registered, label: 'Register Apps', icon: <RegisterSettingsIcon />, color: theme.palette.primary.main },
  ];
};

export const getUserAppItems = (registered, active, users) => {
  return [
    {
      value: registered,
      label: "System Apps",
      icon: <RegisterSettingsIcon />,
      color: theme.palette.primary.main,
    },
    // { value: active, label: 'Active Apps', icon: <UsersIcon/>, color: theme.palette.secondary.main},
    // { value: users, label: 'Register Apps', icon: <UserAppsIcon />, color: theme.palette.primary.light },
  ];
};

export const handleDeleteApps = ({
  selectedApps,
  filteredData,
  dispatchAction,
  dispatch,
  selectedDevice,
  keyName = "PackageFullName",
  command = commandTypes.UN_INST_APP,
}) => {
  const filteredObjects = filteredData.filter((object) =>
    selectedApps.includes(object.id)
  );
  const names = filteredObjects?.map((item) => item?.[keyName]);
  executeCommand(
    names,
    command,
    selectedDevice?.uid,
    selectedDevice?.systemDetails?.os
  );
  const nonFilteredObjects = filteredData.filter(
    (object) => !selectedApps.includes(object.id)
  );
  dispatch(dispatchAction(nonFilteredObjects));
};

export const YupMalwareSearchSchema = {
  hash: string().required("Hash is required"),
};

export const formMalwareSearchSchema = (twoFaSchema) => {
  return {
    resolver: yupResolver(twoFaSchema),
    mode: "onChange",
    defaultValues: {
      otp: "",
    },
  };
};
